<template>
  <v-container class="fill-height" fluid>
    <v-row align="start" justify="center" class="fill-height ml-0 mr-0">
      <v-col md="8" sm="12">
        <v-card class="pa-md-4 pa-sm-2">
          <v-card-title class="d-flex justify-center">
            Suivi d'intervention
          </v-card-title>
          <v-card-subtitle class="d-flex justify-center">
            Description: {{ ticketName }}<br />Réference:
            {{ formatID(ticketId) }}
          </v-card-subtitle>

          <ticket-action
            :ticket-id="ticketId"
            :entity-id="entityId"
            :ticket-status="ticket.status"
            @newComment="addNewITILFollowup"
            @newSolution="addNewITILSolution"
            @newTask="addNewTask"
          ></ticket-action>
          <time-line
            v-if="list.length > 0"
            :list="list"
            :selected-ticket="{
              name: ticketName,
              date_creation: ticketDate,
              content: ticket.content
            }"
          ></time-line>
          <v-skeleton-loader
            ref="skeleton"
            type="list-item-avatar-three-line"
            class="mx-auto"
            v-if="loading"
          ></v-skeleton-loader>
          <div class="d-flex flex-column" v-if="loaded && list.length === 0">
            <v-timeline
              :dense="$vuetify.breakpoint.smAndDown"
              class="timeline__wrapper"
            >
              <v-timeline-item left color="warning" icon class="text-right">
                <template slot="icon">
                  <v-icon x-large class="white--text"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span slot="opposite">
                  <v-chip>
                    <v-icon color="success">access_time </v-icon>
                    {{
                      moment(ticket.date_creation).format("DD/MM/YYYY  HH:mm")
                    }}
                  </v-chip>
                </span>
                <div style="width: 100%" class="d-flex justify-end">
                  <div
                    class="ma-2 success--text text-justify incident description pb-2 pt-2"
                    color="success"
                    outlined
                    x-large
                  >
                    Déclaration d'intervention:
                    <div
                      v-if="ticket.content"
                      v-html="decodeContent(ticket.content)"
                    ></div>
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item right color="grey" icon>
                <template slot="icon">
                  <v-icon x-large class="white--text"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <v-chip class="ma-2" color="grey" outlined>
                  Aucun élement de suivi
                </v-chip>
              </v-timeline-item>
            </v-timeline>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "../../plugins/moment";
import { Decoder } from "../../mixins/decodeContent";
import TimeLine from "../TimeLine";
import TicketAction from "../TicketAction";
import { setupTicketsComponent } from "../../composition/setupTicketsData";
import { formatID } from "@/utils";
import { mapGetters } from "vuex";
import { computed } from "@vue/composition-api";

export default {
  name: "TicketDetail",
  components: { TimeLine, TicketAction },
  props: {
    ticketId: {
      type: Number,
      required: true
    },
    ticketName: {
      type: String,
      default: ""
    },
    ticketDate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      titleText: ""
    };
  },
  setup(props, { root: { $store } }) {
    const ticketId = props.ticketId;
    const tasks = computed(() =>
      $store.getters.getTicketsTasks.filter(
        task => task.tickets_id === ticketId
      )
    );
    const followUps = computed(() =>
      $store.getters.getAllITILFollowups.filter(
        task => task.items_id === ticketId
      )
    );
    const itSolutions = computed(() =>
      $store.getters.getAllITILSolutions.filter(
        task => task.items_id === ticketId
      )
    );

    return {
      ...setupTicketsComponent(ticketId, tasks, followUps, itSolutions),
      formatID,
      tasks,
      followUps,
      itSolutions
    };
  },
  mixins: [Decoder],
  created() {
    this.loadData();
  },
  computed: {
    ...mapGetters(["getActiveEntity", "getTicketsTasks"]),
    entityId() {
      return this.getActiveEntity.id ? this.getActiveEntity.id : NaN;
    }
  },
  methods: {
    moment
  }
};
</script>

<style scoped></style>
